import { format } from 'date-fns';

(async () => {
    const AWIN_CUSTOM_COOKIE = '_awin_data'
    const AWIN_CUSTOM_COOKIE_LIFETIME_DAYS = 30
    const AWIN_GET_PARAM_KEYS = ['awaid', 'awgid', 'awbid', 'awpid', 'awcr', 'awchecksum', 'awc']
    let getParamsCache

    const getGetParams = () => {
        if (!getParamsCache) {
            getParamsCache = window.location.search.replace(/^\?/, '').split('&').map((i) => {
                return { key: i.substring(0, i.indexOf('=')), value: i.substring(i.indexOf('=') + 1, i.length) }
            })
        }
        return getParamsCache
    }
    const isAWINReqeustPresent = async () => {
        return AWIN_GET_PARAM_KEYS.every((i) => {
            /* eslint-disable-next-line no-unused-vars */
            for (let param of getGetParams()) {
                if (param.key === i) {
                    return true
                }
            }
            return false
        })
    }
    const getAWINGetParams = async () => {
        const awinData = {}
        /* eslint-disable-next-line no-unused-vars */
        for (let key of AWIN_GET_PARAM_KEYS) {
            /* eslint-disable-next-line no-await-in-loop */
            awinData[key] = await getGetValueByKey(key)
        }

        // add "click date" to get last awin update
        awinData['awclick'] = format(new Date(), 'dd/MM/yyyy HH:mm:ss')

        return awinData
    }
    const setAWINCustomCookie = async () => {
        const date = new Date()
        date.setDate(date.getDate() + AWIN_CUSTOM_COOKIE_LIFETIME_DAYS)
        const expires = '; expires=' + date.toGMTString()
        const value = JSON.stringify(await getAWINGetParams())
        document.cookie = AWIN_CUSTOM_COOKIE + '=' + value + expires + '; path=/'
    }
    const updateAWINCookie = async () => {
        if (await isAWINReqeustPresent()) {
            setAWINCustomCookie()
        }
    }
    const getGetValueByKey = async (key) => {
        return getGetParams().find(function (i) {
            return i.key === key
        }).value
    }
    await updateAWINCookie()
})()
